module.exports = __webpack_public_path__ + "static/hvhh-1-8a8e9da98f764ab48e3e6f0ce5fcc144.png";